import { render, staticRenderFns } from "./ConversionTable.vue?vue&type=template&id=42cc6a1c&"
import script from "./ConversionTable.vue?vue&type=script&lang=ts&"
export * from "./ConversionTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports